import { render, staticRenderFns } from "./StoresPage.vue?vue&type=template&id=16718a45&scoped=true&"
import script from "./StoresPage.vue?vue&type=script&lang=js&"
export * from "./StoresPage.vue?vue&type=script&lang=js&"
import style0 from "./StoresPage.vue?vue&type=style&index=0&id=16718a45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16718a45",
  null
  
)

export default component.exports